<section class="mx-3">
    <div class="d-flex align-items-center">
        <!-- <div>
            <button mat-icon-button class="back_icon cancel_button me-2" (click)="backnavigation()">
                <i class="fa-solid fa-arrow-left"></i>
            </button>
        </div> -->
        <div class="page_header">
            <h4 translate class="m-0 page_header_title">Leave Summary</h4>
        </div>
    </div>
    <div class="bg-white p-2 my-2">
        <div class="row align-items-center">
            <div class="col-sm-2 col-md-2">
                <div class="d-flex">
                    <div>
                        <p translate class="m-0">Group Actions</p>
                    </div>
                    <div>
                        <div class="action_button" [matMenuTriggerFor]="clearrequest" aria-label="menu">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        <mat-menu #clearrequest="matMenu">
                            <button mat-menu-item class="action_button" (click)="allactionrequestapi()">
                                <span translate>Allot Leaves</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>
            <div class="col-sm-10 col-md-10 align-self-end">
                <div>
                    <form>
                        <div class="row align-items-center m-0">
                            <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 col-xxl-11"> 
                                <div class="row">
                                    <div *ngFor="let question of questions"
                                    class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                                    <app-question [question]="question" [form]="leavesummaryfilterform"></app-question>
                                </div>
                                </div>
                            </div>
                           
                            <!-- <button (click)="submit()">submit</button> -->
                            <div class="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 col-xxl-1">
                                <div>
                                    <div class="action_button" [matMenuTriggerFor]="actionrequest" aria-label="menu">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </div>
                                    <mat-menu #actionrequest="matMenu">
                                        <button mat-menu-item class="action_button" (click)="clearfilters()">
                                            <span translate>Clear Filter</span>
                                        </button>
                                    </mat-menu>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
    <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <!-- <td mat-cell *matCellDef="let row; columns: displayedColumns;"> -->
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th translate mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let row">
                    <div class="d-flex align-items-center">
                        <ng-container>
                            <p translate (click)="gotoemplyeeview(row)" class="mb-0 cursor_pointer view_button">View</p>
                        </ng-container>
                        <ng-container>
                            <div class="action_button" [matMenuTriggerFor]="actionrequest" aria-label="Actions">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                            <mat-menu #actionrequest="matMenu">
                                <button mat-menu-item class="action_button"
                                    (click)="actionrequestapi(row?.employee_id)">
                                    <span translate>Allot Leaves</span>
                                </button>
                            </mat-menu>
                        </ng-container>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="emp_name">
                <th translate mat-header-cell *matHeaderCellDef> Employee Name </th>
                <td mat-cell *matCellDef="let element"> {{element.employee_name}} {{element.last_name}} </td>
            </ng-container>

            <ng-container matColumnDef="designation">
                <th translate mat-header-cell *matHeaderCellDef> Designation </th>
                <td mat-cell *matCellDef="let element"> {{element.designation_name}} </td>
            </ng-container>

            <ng-container matColumnDef="department">
                <th translate mat-header-cell *matHeaderCellDef> Department </th>
                <td mat-cell *matCellDef="let element"> {{element.department_name}} </td>
            </ng-container>

            <ng-container matColumnDef="allotted_leaves">
                <th translate mat-header-cell *matHeaderCellDef> Allotted Leaves </th>
                <td mat-cell *matCellDef="let element"> {{element.total_allocated_leaves}} </td>
            </ng-container>

            <ng-container matColumnDef="used_leaves">
                <th translate mat-header-cell *matHeaderCellDef> Used </th>
                <td mat-cell *matCellDef="let element"> {{element.total_used_leaves}} </td>
            </ng-container>

            <!-- <ng-container matColumnDef="actions" sticky>
            <th mat-header-cell *matHeaderCellDef> Actions</th>
            <td mat-cell *matCellDef="let element"> 
                <div>
                     <div
                    class="action_button"
                    [matMenuTriggerFor]="actionrequest"
                    aria-label="Actions"
                  >
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                    <mat-menu #actionrequest="matMenu">
                        <button mat-menu-item (click)="actionrequestapi('APPROVED', element)">
                          <span>Approved</span>
                        </button>
                        <button mat-menu-item (click)="actionrequestapi('REJECTED', element)">
                          <span>Rejected</span>
                        </button>
                      </mat-menu>
                </div> 
            </td>
        </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td translate class="mat-cell" colspan="4">No data</td>
            </tr>
        </table>
    </div>
    <div class="mt-2" *ngIf="total_count > 5">
        <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
    </div>
</section>